import React, {useRef} from "react";
import UniButton from "../Button";
import Form from "react-bootstrap/Form";
import {ToastFn} from "../../../../modules/worktimetracking/Pages/components/save/SubmitHandler";
import {IntlMessageValue} from "../../component/const/IntlMessage";

interface FileUploadButtonProps{
    required?: boolean;
    classNameInput?: string | undefined;
    styleInput?: React.CSSProperties | undefined;
    id?: string | undefined;
    defaultValue?: string ;
    accept: string;
    ButtonLabel: string;
    DelButtonLabel:string,
    placeholderImg:string;
    classNameButton?: string | undefined;
    styleButton?: React.CSSProperties | undefined;
    name: string;
    defaultSRC?:string,
    img:{
        width:string | undefined,
        height:string | undefined
    }
    validateImage?: {
        width?: number;
        height?: number;
        showToast?: ToastFn;
        userId?: number;
        maxBytes?: number;
        aspectRatio?: number; // 1 = 1:1, 16/9 = 16:9, 4/3 = 4:3
        aspectRatioText?: string;
        aspectTolerance?: number;
    }
}

const  FileUploadButton = (props:FileUploadButtonProps) => {
    const inputFileRef = useRef( null );
    const ImgRef = useRef( null );
    const InputBase64Ref = useRef( null );

    const convertBase64 = (file: Blob) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
                resolve(fileReader.result);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const onFilechange = async ( e:any ) => {
        const [file] = e.target.files
        if (file !== null ) {

            if (props.validateImage?.maxBytes && file.size > props.validateImage.maxBytes) {
                if (props.validateImage?.showToast && props.validateImage?.userId) {
                    const megabytes = props.validateImage.maxBytes / 1024 / 1024;

                    const content = <>{IntlMessageValue("","common.image.to.big", "")} <div className={"text-bold"}>{IntlMessageValue("","common.image.max.size", "") + megabytes + "MB"}</div></>

                    props.validateImage.showToast({
                        func: "showToast",
                        type: "toast",
                        settings: ["variant", "info"],
                        content: content,
                        user: props.validateImage.userId
                    });
                } else {
                    alert('File is too large')
                }
                if(inputFileRef.current) (inputFileRef.current as HTMLInputElement).value = '';
                return;
            }

            const base64 = await convertBase64(file);

            if(props.validateImage?.width || props.validateImage?.height) {
                const img = new Image();
                img.onload = () => {
                    if(
                        (props.validateImage?.width && img.naturalWidth > props.validateImage?.width) ||
                        (props.validateImage?.height && img.naturalHeight > props.validateImage?.height)
                    ) {
                        if (props.validateImage?.showToast && props.validateImage?.userId) {

                            const content =
                                <>
                                    <div>{IntlMessageValue("","common.image.to.big", "")}</div>
                                    {props.validateImage?.width && <div>{IntlMessageValue("","common.image.max.size.width", "")} {props.validateImage?.width} px</div>}
                                    {props.validateImage?.height && <div>{IntlMessageValue("","common.image.max.size.height", "")} {props.validateImage?.height} px</div> }
                                </>

                            props.validateImage.showToast({
                                func: "showToast",
                                type: "toast",
                                settings: ["variant", "info"],
                                content: content,
                                user: props.validateImage.userId
                            });
                        } else {
                            alert('Image is too large')
                        }
                        if(inputFileRef.current) (inputFileRef.current as HTMLInputElement).value = '';
                        return;
                    }

                    if (props.validateImage?.aspectRatio) {
                        const actualRatio = img.naturalWidth / img.naturalHeight;
                        const tolerance = props.validateImage?.aspectTolerance ?? 0.02;

                        if (Math.abs(actualRatio - props.validateImage.aspectRatio) > tolerance) {
                            if (props.validateImage?.showToast && props.validateImage?.userId) {
                                const content =
                                    <>
                                        <div>{IntlMessageValue("", "common.image.wrong.aspect.ratio", "")}</div>
                                        <div>{IntlMessageValue("","common.image.aspect.ratio", "")}: {props.validateImage.aspectRatioText}</div>
                                        <div>{IntlMessageValue("","common.image.aspect.tolerance", "")}: {tolerance * 100 } %</div>
                                    </>;

                                props.validateImage.showToast({
                                    func: "showToast",
                                    type: "toast",
                                    settings: ["variant", "info"],
                                    content: content,
                                    user: props.validateImage.userId
                                });
                            } else {
                                alert('Wrong image aspect ratio')
                            }

                            if(inputFileRef.current) (inputFileRef.current as HTMLInputElement).value = '';
                            return;
                        }
                    }

                    if(ImgRef.current) (ImgRef.current as HTMLImageElement).src = base64 as string;
                    if(InputBase64Ref.current) (InputBase64Ref.current as HTMLInputElement).value =
                        (base64 as string).split('base64,')[1];
                };
                img.src = base64 as string;
                return;
            }




            if(ImgRef.current !== null) {
                (ImgRef.current as HTMLInputElement).src = base64 as string;
            }
            if(InputBase64Ref.current !== null) {
                (InputBase64Ref.current as HTMLInputElement).value = (base64 as string).split('base64,')[1];
            }
        }

    }

    const ClearImg = () => {

        if(ImgRef.current !== null) {
            (ImgRef.current as HTMLInputElement).src = props.placeholderImg;
        }
        if(inputFileRef.current !== null) {
        (inputFileRef.current as HTMLInputElement).value = '';
        }
        if(InputBase64Ref.current !== null) {
            (InputBase64Ref.current as HTMLInputElement).value = '';
        }

    }

    const onBtnClick = () => {
        /*Collecting node-element and performing click*/
        if(inputFileRef.current !== null) {
            (inputFileRef.current as HTMLInputElement).click();
        }

    }

    return (
        <>
            <div className={'text-cetner'}>
                <img src={(props.defaultSRC !== undefined && props.defaultSRC !== null && props.defaultSRC !== '' ? 'data:image/png;base64,'+props.defaultSRC : props.placeholderImg)} ref={ImgRef} className={'border center'} style={{height:props.img.height,width:props.img.width}}/>
            </div>

            <Form.Control ref={InputBase64Ref} name={props.name} defaultValue={props.defaultValue}
                          type={'hidden'}/>
            <Form.Control type={'file'}
                          id={props.id}
                          ref={inputFileRef}
                          style={props.styleInput}
                          className={props.classNameInput}
                          accept={props.accept}
                          required={props.required !== undefined ? props.required : false}
                          onChange={onFilechange}/>
            <UniButton type={'button'} class={props.classNameButton} style={props.styleButton} variant={'primary'}
                       onClick={onBtnClick}>{props.ButtonLabel}</UniButton>

            <UniButton type={'button'} class={props.classNameButton} style={props.styleButton} variant={'danger'}
                       onClick={ClearImg}>{props.DelButtonLabel}</UniButton>
        </>
    )
}

export default FileUploadButton;
